export default "__VITE_ASSET__ba457406__"